'use strict';

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var applyDefaultOptions = require('./utils/apply-default-options');

var toMfsPath = require('./utils/to-mfs-path');

var log = require('debug')('ipfs:mfs:touch');

var errCode = require('err-code');

var UnixFS = require('ipfs-unixfs');

var toTrail = require('./utils/to-trail');

var addLink = require('./utils/add-link');

var updateTree = require('./utils/update-tree');

var updateMfsRoot = require('./utils/update-mfs-root');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var mc = require('multicodec');

var mh = require('multihashes');

var pipe = require('it-pipe');

var importer = require('ipfs-unixfs-importer');

var exporter = require('ipfs-unixfs-exporter');

var last = require('it-last');

var cp = require('./cp');

var rm = require('./rm');

var persist = require('ipfs-unixfs-importer/src/utils/persist');

var _require2 = require('../../utils'),
    withTimeoutOption = _require2.withTimeoutOption;

var defaultOptions = {
  flush: true,
  shardSplitThreshold: 1000,
  hashAlg: 'sha2-256',
  cidVersion: 0,
  recursive: false
};

function calculateModification(mode, originalMode, isDirectory) {
  var modification = 0;

  if (mode.includes('x') || mode.includes('X') && (isDirectory || originalMode & 1 || originalMode & 8 || originalMode & 64)) {
    modification += 1;
  }

  if (mode.includes('w')) {
    modification += 2;
  }

  if (mode.includes('r')) {
    modification += 4;
  }

  return modification;
}

function calculateUGO(references, modification) {
  var ugo = 0;

  if (references.includes('u')) {
    ugo += modification << 6;
  }

  if (references.includes('g')) {
    ugo += modification << 3;
  }

  if (references.includes('o')) {
    ugo += modification;
  }

  return ugo;
}

function calculateSpecial(references, mode, modification) {
  if (mode.includes('t')) {
    modification += parseInt('1000', 8);
  }

  if (mode.includes('s')) {
    if (references.includes('u')) {
      modification += parseInt('4000', 8);
    }

    if (references.includes('g')) {
      modification += parseInt('2000', 8);
    }
  }

  return modification;
} // https://en.wikipedia.org/wiki/Chmod#Symbolic_modes


function parseSymbolicMode(input, originalMode, isDirectory) {
  if (!originalMode) {
    originalMode = 0;
  }

  var match = input.match(/^(u?g?o?a?)(-?\+?=?)?(r?w?x?X?s?t?)$/);

  if (!match) {
    throw new Error("Invalid file mode: ".concat(input));
  }

  var _match = _slicedToArray(match, 4),
      _ = _match[0],
      // eslint-disable-line no-unused-vars
  references = _match[1],
      operator = _match[2],
      mode = _match[3];

  if (references === 'a' || !references) {
    references = 'ugo';
  }

  var modification = calculateModification(mode, originalMode, isDirectory);
  modification = calculateUGO(references, modification);
  modification = calculateSpecial(references, mode, modification);

  if (operator === '=') {
    if (references.includes('u')) {
      // blank u bits
      originalMode = originalMode & parseInt('7077', 8); // or them together

      originalMode = originalMode | modification;
    }

    if (references.includes('g')) {
      // blank g bits
      originalMode = originalMode & parseInt('7707', 8); // or them together

      originalMode = originalMode | modification;
    }

    if (references.includes('o')) {
      // blank o bits
      originalMode = originalMode & parseInt('7770', 8); // or them together

      originalMode = originalMode | modification;
    }

    return originalMode;
  }

  if (operator === '+') {
    return modification | originalMode;
  }

  if (operator === '-') {
    return modification ^ originalMode;
  }
}

function calculateMode(mode, metadata) {
  if (typeof mode === 'string' || mode instanceof String) {
    if (mode.match(/^\d+$/g)) {
      mode = parseInt(mode, 8);
    } else {
      mode = mode.split(',').reduce(function (curr, acc) {
        return parseSymbolicMode(acc, curr, metadata.isDirectory());
      }, metadata.mode);
    }
  }

  return mode;
}

module.exports = function (context) {
  return withTimeoutOption( /*#__PURE__*/function () {
    var _mfsChmod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, mode, options) {
      var _yield$toMfsPath, cid, mfsDirectory, name, root, node, metadata, updatedCid, trail, parent, parentNode, result, newRootCid;

      return _regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              options = applyDefaultOptions(options, defaultOptions);
              log("Fetching stats for ".concat(path));
              _context5.next = 4;
              return toMfsPath(context, path);

            case 4:
              _yield$toMfsPath = _context5.sent;
              cid = _yield$toMfsPath.cid;
              mfsDirectory = _yield$toMfsPath.mfsDirectory;
              name = _yield$toMfsPath.name;

              if (!(cid.codec !== 'dag-pb')) {
                _context5.next = 10;
                break;
              }

              throw errCode(new Error("".concat(path, " was not a UnixFS node")), 'ERR_NOT_UNIXFS');

            case 10:
              if (!options.recursive) {
                _context5.next = 19;
                break;
              }

              _context5.next = 13;
              return pipe( /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry, _node;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _context.prev = 2;
                        _iterator = _asyncIterator(exporter.recursive(cid, context.ipld));

                      case 4:
                        _context.next = 6;
                        return _awaitAsyncGenerator(_iterator.next());

                      case 6:
                        _step = _context.sent;
                        _iteratorNormalCompletion = _step.done;
                        _context.next = 10;
                        return _awaitAsyncGenerator(_step.value);

                      case 10:
                        _value = _context.sent;

                        if (_iteratorNormalCompletion) {
                          _context.next = 23;
                          break;
                        }

                        entry = _value;
                        _context.next = 15;
                        return _awaitAsyncGenerator(context.ipld.get(entry.cid));

                      case 15:
                        _node = _context.sent;
                        entry.unixfs.mode = calculateMode(mode, entry.unixfs);
                        _node = new DAGNode(entry.unixfs.marshal(), _node.Links);
                        _context.next = 20;
                        return {
                          path: entry.path,
                          content: _node
                        };

                      case 20:
                        _iteratorNormalCompletion = true;
                        _context.next = 4;
                        break;

                      case 23:
                        _context.next = 29;
                        break;

                      case 25:
                        _context.prev = 25;
                        _context.t0 = _context["catch"](2);
                        _didIteratorError = true;
                        _iteratorError = _context.t0;

                      case 29:
                        _context.prev = 29;
                        _context.prev = 30;

                        if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                          _context.next = 34;
                          break;
                        }

                        _context.next = 34;
                        return _awaitAsyncGenerator(_iterator.return());

                      case 34:
                        _context.prev = 34;

                        if (!_didIteratorError) {
                          _context.next = 37;
                          break;
                        }

                        throw _iteratorError;

                      case 37:
                        return _context.finish(34);

                      case 38:
                        return _context.finish(29);

                      case 39:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[2, 25, 29, 39], [30,, 34, 38]]);
              })), function (source) {
                return importer(source, context.block, _objectSpread(_objectSpread({}, options), {}, {
                  pin: false,
                  dagBuilder: function () {
                    var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(source, block, options) {
                      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2, _value2;

                      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _iteratorNormalCompletion2 = true;
                              _didIteratorError2 = false;
                              _context4.prev = 2;
                              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                                var entry;
                                return _regeneratorRuntime.wrap(function _loop$(_context3) {
                                  while (1) {
                                    switch (_context3.prev = _context3.next) {
                                      case 0:
                                        entry = _value2;
                                        _context3.next = 3;
                                        return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                                          var cid;
                                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                            while (1) {
                                              switch (_context2.prev = _context2.next) {
                                                case 0:
                                                  _context2.next = 2;
                                                  return persist(entry.content.serialize(), block, options);

                                                case 2:
                                                  cid = _context2.sent;
                                                  return _context2.abrupt("return", {
                                                    cid: cid,
                                                    path: entry.path,
                                                    unixfs: UnixFS.unmarshal(entry.content.Data),
                                                    node: entry.content
                                                  });

                                                case 4:
                                                case "end":
                                                  return _context2.stop();
                                              }
                                            }
                                          }, _callee2);
                                        }));

                                      case 3:
                                      case "end":
                                        return _context3.stop();
                                    }
                                  }
                                }, _loop);
                              });
                              _iterator2 = _asyncIterator(source);

                            case 5:
                              _context4.next = 7;
                              return _awaitAsyncGenerator(_iterator2.next());

                            case 7:
                              _step2 = _context4.sent;
                              _iteratorNormalCompletion2 = _step2.done;
                              _context4.next = 11;
                              return _awaitAsyncGenerator(_step2.value);

                            case 11:
                              _value2 = _context4.sent;

                              if (_iteratorNormalCompletion2) {
                                _context4.next = 17;
                                break;
                              }

                              return _context4.delegateYield(_loop(), "t0", 14);

                            case 14:
                              _iteratorNormalCompletion2 = true;
                              _context4.next = 5;
                              break;

                            case 17:
                              _context4.next = 23;
                              break;

                            case 19:
                              _context4.prev = 19;
                              _context4.t1 = _context4["catch"](2);
                              _didIteratorError2 = true;
                              _iteratorError2 = _context4.t1;

                            case 23:
                              _context4.prev = 23;
                              _context4.prev = 24;

                              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                                _context4.next = 28;
                                break;
                              }

                              _context4.next = 28;
                              return _awaitAsyncGenerator(_iterator2.return());

                            case 28:
                              _context4.prev = 28;

                              if (!_didIteratorError2) {
                                _context4.next = 31;
                                break;
                              }

                              throw _iteratorError2;

                            case 31:
                              return _context4.finish(28);

                            case 32:
                              return _context4.finish(23);

                            case 33:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee3, null, [[2, 19, 23, 33], [24,, 28, 32]]);
                    }));

                    return function dagBuilder(_x, _x2, _x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }()
                }));
              }, function (nodes) {
                return last(nodes);
              });

            case 13:
              root = _context5.sent;
              _context5.next = 16;
              return rm(context)(path, options);

            case 16:
              _context5.next = 18;
              return cp(context)("/ipfs/".concat(root.cid), path, options);

            case 18:
              return _context5.abrupt("return");

            case 19:
              _context5.next = 21;
              return context.ipld.get(cid);

            case 21:
              node = _context5.sent;
              metadata = UnixFS.unmarshal(node.Data);
              metadata.mode = calculateMode(mode, metadata);
              node = new DAGNode(metadata.marshal(), node.Links);
              _context5.next = 27;
              return context.ipld.put(node, mc.DAG_PB, {
                cidVersion: cid.version,
                hashAlg: mh.names[options.hashAlg],
                onlyHash: !options.flush
              });

            case 27:
              updatedCid = _context5.sent;
              _context5.next = 30;
              return toTrail(context, mfsDirectory, options);

            case 30:
              trail = _context5.sent;
              parent = trail[trail.length - 1];
              _context5.next = 34;
              return context.ipld.get(parent.cid);

            case 34:
              parentNode = _context5.sent;
              _context5.next = 37;
              return addLink(context, {
                parent: parentNode,
                name: name,
                cid: updatedCid,
                size: node.serialize().length,
                flush: options.flush,
                hashAlg: options.hashAlg,
                cidVersion: cid.version
              });

            case 37:
              result = _context5.sent;
              parent.cid = result.cid; // update the tree with the new child

              _context5.next = 41;
              return updateTree(context, trail, options);

            case 41:
              newRootCid = _context5.sent;
              _context5.next = 44;
              return updateMfsRoot(context, newRootCid);

            case 44:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4);
    }));

    function mfsChmod(_x4, _x5, _x6) {
      return _mfsChmod.apply(this, arguments);
    }

    return mfsChmod;
  }());
};